import {
  Breakpoint,
  useTheme,
  useMediaQuery,
} from '@forgeglobal/design-framework';

/**
 * @param breakpoint The MUI breakpoint e.g 'sx', 'sm', 'md', 'lg', 'xl'. Function
 * will return the number value of 1 or maxColumn number you passed in based
 * on whether or not you passed the breakpoint argument.
 * @param maxColumns number of columns allowed before hitting breakpoint
 * @returns number value of columns at breakpoint for mobile.
 */
const useMasonryDynamicColumns = (
  breakpoint: Breakpoint,
  maxColumns: number
) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up(breakpoint));

  return matches ? maxColumns : 1;
};

export default useMasonryDynamicColumns;
